import IApplicationVm from "./IApplicationVm"
import ICriminalRecordDeclarationVm from "./ICriminalRecordDeclarationVm"

import * as IApplicationVmInstance from "./IApplicationVm"
import * as ICriminalRecordDeclarationVmInstance from "./ICriminalRecordDeclarationVm"

export default interface IApplicationForStaVm extends IApplicationVm {
    previousApplicationForSta: IApplicationForStaVm
    hasForeignCertificateOrEducation: boolean
    criminalRecordDeclaration: ICriminalRecordDeclarationVm
}

export const empty = (enableIteration: boolean = true): IApplicationForStaVm => {
	return {
		...IApplicationVmInstance.empty(),
		previousApplicationForSta: enableIteration ? empty(false) : null,
		hasForeignCertificateOrEducation: false,
		criminalRecordDeclaration: ICriminalRecordDeclarationVmInstance.empty()
	} as IApplicationForStaVm
}